import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { FolderClient } from 'api/clients/FolderClient'
import { Assignee, AssigneeType } from 'api/clients/PropertyClient'
import { ArticleService } from 'api/services/ArticleService'
import { showSuccessfulMoveToast } from 'common/ToastMessage/showMoveToast'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { ActionConfig, ActionType, MoveFileActionConfig } from 'stores/Workflows/Types'
import { getFolderPath } from 'utils/urlUtils'

export type TransitionEffectPayload = { [type in ActionType]?: ActionConfig | null }
export type MaybeTransitionEffectPayload = TransitionEffectPayload | null | undefined

export const runAfterTransitionEffects = (assignee: Assignee, payload?: MaybeTransitionEffectPayload) => {
  if (!payload) return

  if (payload['files.move']) {
    if (assignee.type === AssigneeType.Article) {
      ArticleService.getArticle(assignee.id)
    }
    FolderClient.getFolder((payload['files.move'] as MoveFileActionConfig).destination_folder_key).then((response) => {
      if (response.type === SUCCESS_RESPONSE_TYPE) {
        const { folder } = response.data
        if (!folder.handbook) {
          return
        }
        const url = getFolderPath({ folderSlug: folder.handbook.seo_string })
        showSuccessfulMoveToast(1, url, folder.title)
      }
    })
  }

  if (payload['accesses.create']) {
    showToastMessage('File shared successfully!')
  }

  if (payload['files.copy']) {
    showToastMessage('File copied successfully!')
  }
}
